"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var ExpandableSectionWrapper = /** @class */ (function (_super) {
    __extends(ExpandableSectionWrapper, _super);
    function ExpandableSectionWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExpandableSectionWrapper.prototype.findHeader = function () {
        return this.find('.awsui-expandable-section-header');
    };
    ExpandableSectionWrapper.prototype.findContent = function () {
        return this.find('.awsui-expandable-section-content');
    };
    ExpandableSectionWrapper.prototype.findExpandedContent = function () {
        return this.find('.awsui-expandable-section-content-expanded');
    };
    ExpandableSectionWrapper.prototype.findExpandIcon = function () {
        return this.find('.awsui-expandable-section-header-icon');
    };
    return ExpandableSectionWrapper;
}(dom_1.ComponentWrapper));
exports.default = ExpandableSectionWrapper;
//# sourceMappingURL=awsui-expandable-section.js.map